//lib
import styled from "styled-components";
import { Checkbox, FormControlLabel } from "@mui/material";

export const CheckboxStyled = styled(Checkbox)`
  color: #301d35 !important;
  &.Mui-checked {
    color: #301d35 !important;
  }
  &.Mui-disabled {
    color: #dbdfe6 !important;
  }
`;

export const FormControlLabelStyled = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    user-select: none;
    color: #301d35;
    font-size: 13px;
    width: ${(props) => (props.labelWidth ? props.labelWidth : "auto")};
    text-align: ${(props) =>
      props.labelPlacement === "start" ? "right" : "left"};
  }
`;
